function $92c58f6c778295f4$export$2e2bcd8739ae039(str) {
    if (str instanceof Date) return str;
    if (!str || typeof str !== "string") return null;
    const dateTime = str.replace(" ", "T");
    let dateObj = new Date(dateTime);
    if (Number.isNaN(dateObj.getTime())) {
        const [dateStr, timeStr] = str.split(" ");
        const [year, month, date] = dateStr.split("-").map(Number);
        let dateArgs = [
            year,
            month - 1,
            date
        ];
        if (timeStr) dateArgs = [
            ...dateArgs,
            ...timeStr.split(":").map(Number)
        ];
        dateObj = new Date(...dateArgs);
    }
    if (Number.isNaN(dateObj.getTime())) return null;
    return dateObj;
}


function $bd8ef86fc8092892$export$2e2bcd8739ae039(num, places = 2) {
    return String(num).padStart(places, "0");
}


function $faf6c6b9550e8f86$export$2e2bcd8739ae039(string, placeholders = {}) {
    let substitutedString = string;
    Object.entries(placeholders).forEach(([find, replace])=>{
        substitutedString = substitutedString.replace(new RegExp(`:${find}`, "g"), replace);
    });
    return substitutedString;
}


function $f656762f7d85d341$export$2e2bcd8739ae039(string, value = null) {
    if (value === null) return string;
    const options = string.split("|");
    if (options.length === 1) return options[0];
    const brackets = /\[([^\]]+)]/;
    let foundValue = null;
    options.forEach((option)=>{
        const bracketMatch = option.match(brackets);
        if (bracketMatch && bracketMatch.length > 1) {
            const [start, end] = bracketMatch[1].split(",").map((item)=>item === "Inf" ? item : parseInt(item, 10));
            if (value >= start && (end === "Inf" || value < end || end === undefined)) foundValue = option.replace(brackets, "").trim();
        }
    });
    if (!foundValue) foundValue = value === 1 ? options[0] : options[1];
    return foundValue;
}


function $93e53cdbe5e6a727$export$2e2bcd8739ae039([firstLetter, ...restOfWord]) {
    return firstLetter.toUpperCase() + restOfWord.join("");
}


const $da5445ebe7bb0bc9$var$_objToQuery = (obj, exclude = [], parent = null)=>{
    return Object.entries(obj).filter(([key])=>!exclude.includes(key)).flatMap(([key, value])=>{
        const queryKey = parent ? `${parent}[${key}]` : key;
        if (Array.isArray(value)) return value.map((subValue)=>`${queryKey}[]=${subValue}`);
        if (typeof value === "object" && value !== null) return $da5445ebe7bb0bc9$var$_objToQuery(value, exclude, queryKey);
        return `${queryKey}=${value}`;
    }).join("&");
};
function $da5445ebe7bb0bc9$export$2e2bcd8739ae039(obj, exclude = []) {
    return $da5445ebe7bb0bc9$var$_objToQuery(obj, exclude);
}




export {$92c58f6c778295f4$export$2e2bcd8739ae039 as strToDate, $bd8ef86fc8092892$export$2e2bcd8739ae039 as zeroPad, $faf6c6b9550e8f86$export$2e2bcd8739ae039 as replacePlaceholders, $f656762f7d85d341$export$2e2bcd8739ae039 as choice, $93e53cdbe5e6a727$export$2e2bcd8739ae039 as capitalize, $da5445ebe7bb0bc9$export$2e2bcd8739ae039 as objToQuery};
//# sourceMappingURL=module.js.map
